
import Cribbage from '../../../CribbageCore/src/Game/Cribbage.js'

import PIXI from '../GameEngine/pixi.js';
import Card from '../Sprites/Card.js'
import Cards from '../Sprites/Cards.js'
import Button from '../Sprites/ButtonSolid.js'
import ButtonSmall from '../Sprites/ButtonSmall.js'
import ButtonSmallInfo from '../Sprites/ButtonSmallInfo.js'
import PopUpMessage from '../Sprites/PopUpMessage.js'
import ScoreBoard from '../Sprites/ScoreBoard.js'
import PlayerScoreBoard from '../Sprites/PlayerScoreBoard.js'
import PlayerScoreBoardMini from '../Sprites/PlayerScoreBoardMini.js'
import RoundSummaryWindow from '../Sprites/RoundSummaryWindow.js'
import MatchSummary from '../Sprites/MatchSummaryWindow.js'
import RoundSummary from '../Sprites/RoundSummaryHorizontal.js'
import RoundOver from '../Sprites/RoundOver.js'
import HandAnalyzerPanel from '../Sprites/HandAnalyzerPanel.js'
import ScoreDetails from '../Sprites/ScoreDetails.js'
import GameOver from '../Sprites/GameOver.js'
import TurnIndicator from '../Sprites/TurnIndicator.js'
import CribbageBoard from '../Sprites/CribbageBoard.js'
import TurnTimer from '../Sprites/TurnTimer.js'
import DialogBox from '../Sprites/DialogBox.js'
import ChatBubble from '../Sprites/ChatBubble.js'
import ChatSelection from '../Sprites/ChatSelection.js'

import PileLayoutLandscape from './Layouts/LayoutLandscape.js';
import PileLayoutLandscapeFlipped from './Layouts/LayoutLandscapeFlipped.js';
import PileLayoutLandscapeTest from './Layouts/LayoutLandscapeTest.js';
import PileLayoutLandscapeSpectate from './Layouts/LayoutLandscapeSpectate.js';
import PileLayoutPortrait from './Layouts/LayoutPortrait.js';
import PileLayoutPortraitFlipped from './Layouts/LayoutPortraitFlipped.js';
import PileLayoutPortraitTest from './Layouts/LayoutPortraitTest.js';
import PileLayoutPortraitSpectate from './Layouts/LayoutPortraitSpectate.js';

import LayoutManager from './Layouts/LayoutManager.js';

export default class GameScene {
    constructor(app, cribbage, audio) {
        this.app = app || {};
        this.audio = audio;
        this.stageWidth = 800;
        this.stageHeight = 500;
        //this.loader = new PIXI.Loader();
        this.isLoaded = false;
        this.stage = new PIXI.Container();
        this.cribbage = cribbage;
        this.tablePosition = "player1";
        this.isChatMuted = false;
        this.isAudioMuted = this.app.isMuted;
        this.debug = false;
        this.isCreated = false;
        this.currentState = null;

        //eventListeners
        this.onCardMovedEventListener = this.onCardMoved.bind(this);
        this.onStateChangedEventListener = this.onStateChanged.bind(this);
        this.onActionStartEventListener = this.onActionStart.bind(this);
        this.onActionEndedEventListener = this.onActionEnded.bind(this);
        this.onAwardPointsEventListener = this.onAwardPoints.bind(this);
        this.onHandPointsEventListener = this.onHandPoints.bind(this);
        this.onMatchPointsEventListener = this.onMatchPoints.bind(this);
        this.onMessageEventListener = this.onMessage.bind(this);
        this.onInvalidMoveEventListener = this.onInvalidMove.bind(this);
        this.onJoinEventListener = this.onJoin.bind(this);
        this.onLeaveEventListener = this.onLeave.bind(this);
        this.onDisconnectEventListener = this.onDisconnect.bind(this);
        this.onStartPlayTimerEventListener = this.onStartPlayTimer.bind(this);
        this.onChatEventListener = this.onChat.bind(this);
        this.onDataEventListener = this.onData.bind(this);


        //todo: remove all ties to "app" and just send events 
        this.layoutManager = new LayoutManager();
        this.pileLayoutLandscape = PileLayoutLandscape;
        this.pileLayoutLandscapeFlipped = PileLayoutLandscapeFlipped;
        this.pileLayoutLandscapeTest = PileLayoutLandscapeTest;
        this.pileLayoutLandscapeSpectate = PileLayoutLandscapeSpectate;
        this.pileLayoutPortrait = PileLayoutPortrait;
        this.pileLayoutPortraitFlipped = PileLayoutPortraitFlipped;
        this.pileLayoutPortraitTest = PileLayoutPortraitTest;
        this.pileLayoutPortraitSpectate = PileLayoutPortraitSpectate;

        this.pileLayout = this.pileLayoutLandscape;
    }
    init(cribbage, tablePosition, lastPage) {
        if (cribbage) {
            this.cribbage = cribbage;
        }
        if (!this.cribbage) {
            this.cribbage = new Cribbage();
            this.cribbage.debug = true;
        }
        this.debug = this.cribbage.debug;
        this.isChatMuted = this.cribbage.isChatMuted;
        this.board = this.cribbage.boardName;
        this.deckName = this.cribbage.deckName;
        if (this.gameOver) this.gameOver.visible = false;
        //if (this.roundSummary) this.roundSummary.visible = false;
        if (this.handAnalyzerPanel) this.handAnalyzerPanel.visible = false;

        this.cribbage.event.addListener("cardMoved", this.onCardMovedEventListener);
        this.cribbage.event.addListener("stateChange", this.onStateChangedEventListener);
        this.cribbage.event.addListener("action", this.onActionStartEventListener);
        this.cribbage.event.addListener("actionEnded", this.onActionEndedEventListener);
        this.cribbage.event.addListener("awardPointArray", this.onAwardPointsEventListener);
        this.cribbage.event.addListener("handPoints", this.onHandPointsEventListener);
        this.cribbage.event.addListener("matchPoints", this.onMatchPointsEventListener);
        this.cribbage.event.addListener("message", this.onMessageEventListener);
        this.cribbage.event.addListener("invalidMove", this.onInvalidMoveEventListener);
        this.cribbage.event.addListener("join", this.onJoinEventListener);
        this.cribbage.event.addListener("leave", this.onLeaveEventListener);
        this.cribbage.event.addListener("disconnect", this.onDisconnectEventListener);
        this.cribbage.event.addListener("startPlayTimer", this.onStartPlayTimerEventListener);
        this.cribbage.event.addListener("chat", this.onChatEventListener);
        this.cribbage.event.addListener("data", this.onDataEventListener);

        this.lastPage = lastPage;
        // if (localUserName) this.localUserName = localUserName;
        // if(this.cribbage.player1 && this.localUserName === this.cribbage.player1.name){
        //     this.localPlayer = "player1";
        // }
        // if(this.cribbage.player2 && this.localUserName === this.cribbage.player2.name){
        //     this.localPlayer = "player2";
        // }

        //if (tablePosition) this.tablePosition = tablePosition;
        this.tablePosition = tablePosition;


        //this.pileLayout = this.getLayout(this.tablePosition);

        //    // if (this.debug)
        //    if(this.debug || this.cribbage && this.cribbage.debug )
        //         this.pileLayout = this.pileLayoutLandscapeTest;  
    }
    getLayout(tablePosition, orientation) {
        if (!orientation) orientation = "landscape";

        if (orientation === "landscape") {
            //landscape
            if (tablePosition === "player1") //switch back to player1 after testing
                return this.pileLayoutLandscape;
            else if (tablePosition === "player2")
                return this.pileLayoutLandscapeFlipped;
            else if (tablePosition === "test")
                return this.pileLayoutLandscapeTest;
            else
                return this.pileLayoutLandscapeSpectate;
        } else {
            //portrait
            if (tablePosition === "player1") //switch back to player1 after testing
                return this.pileLayoutPortrait;
            else if (tablePosition === "player2")
                return this.pileLayoutPortraitFlipped;
            else if (tablePosition === "test")
                return this.pileLayoutPortraitTest;
            else
                return this.pileLayoutPortraitSpectate;
        }
    }
    reload(cribbage, tablePosition, lastPage) {
        this.shutdown(); //added as it may not have shut down before
        this.init(cribbage, tablePosition, lastPage);
        //skip create()
        this.updateLayout();
        this.onStateChanged();
    }
    shutdown() {
        //cleaup  this.cribbage 
        //this.cribbage.destroy();
        if (this.cribbage) {
            // this.cribbage.event.removeAllListener();
            this.cribbage.event.removeListener("cardMoved", this.onCardMovedEventListener);
            this.cribbage.event.removeListener("stateChange", this.onStateChangedEventListener);
            this.cribbage.event.removeListener("action", this.onActionStartEventListener);
            this.cribbage.event.removeListener("actionEnded", this.onActionEndedEventListener);
            this.cribbage.event.removeListener("awardPointArray", this.onAwardPointsEventListener);
            this.cribbage.event.removeListener("handPoints", this.onHandPointsEventListener);
            this.cribbage.event.removeListener("matchPoints", this.onMatchPointsEventListener);
            this.cribbage.event.removeListener("message", this.onMessageEventListener);
            this.cribbage.event.removeListener("invalidMove", this.onInvalidMoveEventListener);
            this.cribbage.event.removeListener("join", this.onJoinEventListener);
            this.cribbage.event.removeListener("leave", this.onLeaveEventListener);
            this.cribbage.event.removeListener("disconnect", this.onDisconnectEventListener);
            this.cribbage.event.removeListener("startPlayTimer", this.onStartPlayTimerEventListener);
            this.cribbage.event.removeListener("chat", this.onChatEventListener);
            this.cribbage.event.removeListener("data", this.onDataEventListener);

        }
        this.cribbage = new Cribbage();
        this.updateLayout();
    }
    destroy() {
        this.isDestroyed = true;
        this.shutdown();
        if (this.stage) {
            this.stage.destroy({ children: true, texture: true, baseTexture: true });
        }
        this.stage = null;
        this.app = null;
        this.cribbage = null;
    }
    preload(callback) {
        //todo: load all
        //todo: pass loader in change PIXI.Loader.shared -> this.loader

        var loader = PIXI.Loader.shared;


        //buttons
        loader.add("BackButton", "assets/Buttons/BackButton.png");
        loader.add("ChatButton", "assets/Buttons/ChatButton.png");
        loader.add("AddFriendButton", "assets/Buttons/AddFriend.png");
        loader.add("AudioButton", "assets/Buttons/AudioButton.png");
        loader.add("AudioMuteButton", "assets/Buttons/AudioMuteButton.png");
        //Blank button
        //loader.add("ButtonBlankShadow", "assets/Buttons/ButtonBlankShadow.png");

        //avatar
        loader.add("Avatar", "assets/Avatars/agent.png");
        loader.add("Avatar_Computer", "assets/Avatars/default-avatar.png");
        loader.add("Avatar_Disconnected", "assets/Avatars/disconnected.png");
        loader.add("disconnected", "assets/Game/disconnected.png");
        loader.add("chatMute", "assets/Game/microphoneMute.png");

        //game
        //loader.add("assets/Decks/PirateDeck200_SpriteSheet@2x.json");
        //loader.add("assets/Decks/DualSideDeck_SpriteSheet.json");
        //loader.add("assets/Decks/PixaromaDeck_SpriteSheet.json");
        loader.add("Deck", "assets/Decks/PixaromaDeck_SpriteSheet.json");   //cards
        //backgrounds
        loader.add("WoodBackground", "assets/Backgrounds/WoodBackground.png");
        loader.add("BlueBackground", "assets/Backgrounds/BlueBackground.png");
        loader.add("GreenBackground", "assets/Backgrounds/GreenBackground.png");
        loader.add("GreenLightBackground", "assets/Backgrounds/GreenLightBackground.png");
        loader.add("RedBackground", "assets/Backgrounds/RedBackground.png");
        //loader.add("FantasyBackground", "assets/Backgrounds/FantasyBackground.png");
        //loader.add("TrainBackground", "assets/Backgrounds/TrainBackground.png");

        // loader.add("MicrophoneButton", "assets/Game/Microphone.png");
        // loader.add("MicrophoneMuteButton", "assets/Game/MicrophoneMute.png");
        loader.add("peg1", "assets/CribbageBoards/Peg_Blue.png");
        loader.add("peg2", "assets/CribbageBoards/Peg_Red.png");

        loader.add("assets/Badges/Badges.json");
        //cribbage board
        loader.add("CribbageBoard", "assets/CribbageBoards/CribbageBoard_Tall_Wood_RedBlue.png");

        //sounds
        //https://pixijs.io/pixi-sound/docs/PIXI.sound.html

        // loader.add('CardClick', 'assets/Audio/click_lower_volumn.wav');
        // loader.add('PointSound', 'assets/Audio/whoop.wav');
        // loader.add('AchivementSound', 'assets/Audio/chime.wav');
        // loader.add('WinSound', 'assets/Audio/win.wav');
        loader.load((loader, resources) => {
            this.create();
            this.isLoaded = true;
            if (callback) callback(loader, resources);
        });
    }
    create() {

        //this.cardUIs = [];
        //let blength = PIXI.utils.BaseTextureCache;
        //todo: new PIXI.Text( is creating a new texture each time the game is loaded

        //background
        let textureBackground = PIXI.Loader.shared.resources['WoodBackground'].texture;
        this.background = new PIXI.Sprite(textureBackground);
        this.stage.addChild(this.background);



        //exit button
        this.buttonExit = new PIXI.Sprite(PIXI.Loader.shared.resources['BackButton'].texture);
        this.buttonExit.interactive = true;
        this.buttonExit.on('pointerdown', this.buttonExit_onClick.bind(this));
        this.stage.addChild(this.buttonExit);


        //add audio mute toggle button 
        this.buttonAudio = new PIXI.Sprite(PIXI.Loader.shared.resources['AudioButton'].texture);
        this.buttonAudio.interactive = true;
        this.buttonAudio.on('pointerdown', this.buttonMute_onClick.bind(this));
        this.stage.addChild(this.buttonAudio);

        //add audio mute toggle button 
        this.buttonAudioMute = new PIXI.Sprite(PIXI.Loader.shared.resources['AudioMuteButton'].texture);
        this.buttonAudioMute.interactive = true;
        this.buttonAudioMute.visible = false;
        this.buttonAudioMute.on('pointerdown', this.buttonMute_onClick.bind(this));
        this.stage.addChild(this.buttonAudioMute);


        //chat button 
        this.buttonChat = new PIXI.Sprite(PIXI.Loader.shared.resources['ChatButton'].texture);
        this.buttonChat.interactive = true;
        this.buttonChat.on('pointerdown', this.buttonChat_onClick.bind(this));
        this.stage.addChild(this.buttonChat);



        //create CribbageBoard
        this.cribbageBoard = new CribbageBoard(this.cribbage.boardName);
        this.stage.addChild(this.cribbageBoard);
        this.cribbageBoard.updateLayout();

        //playBackground playBackground
        //x: 625, y: 250
        this.playBackground = new PIXI.Graphics();
        this.playBackground.beginFill(0x000000);
        this.playBackground.drawRoundedRect(0, 0, 280, 140, 10);
        this.stage.addChild(this.playBackground);




        //Player scoreboard 1
        this.profile1 = new PlayerScoreBoard("", "", 0x479ACE);
        if (this.cribbage.player1)
            this.profile1.name = this.cribbage.player1.name;
        else
            this.profile1.name = "";
        this.profile1.interactive = true;
        this.profile1.on('pointerdown', this.profile1_onClick.bind(this));
        this.stage.addChild(this.profile1);

        //Player scoreboard 2
        this.profile2 = new PlayerScoreBoard("", "", 0xC03500);
        if (this.cribbage.player2)
            this.profile2.name = this.cribbage.player2.name;
        else
            this.profile2.name = "";
        this.profile2.interactive = true;
        this.profile2.on('pointerdown', this.profile2_onClick.bind(this));
        this.stage.addChild(this.profile2);

        //Disconnected indicator 1
        this.player1Disconnected = new PIXI.Sprite(PIXI.Loader.shared.resources['disconnected'].texture);
        this.stage.addChild(this.player1Disconnected);

        //Disconnected indicator 2
        this.player2Disconnected = new PIXI.Sprite(PIXI.Loader.shared.resources['disconnected'].texture);
        this.stage.addChild(this.player2Disconnected);

        //ChatMute indicator (always top)
        this.chatMute = new PIXI.Sprite(PIXI.Loader.shared.resources['chatMute'].texture);
        this.stage.addChild(this.chatMute);

    //    //buttonAddFriend 
    //     this.buttonAddFriend = new ButtonSmall("+Friend", 0x218414, 100);
    //     this.buttonAddFriend.interactive = true;
    //     this.buttonAddFriend.on('pointerdown', this.buttonAddFriend_onClick.bind(this));
    //     this.stage.addChild(this.buttonAddFriend);
        // //buttonReport 
        // this.buttonReport = new ButtonSmall("Block", 0xC03510, 100);
        // this.buttonReport.interactive = true;
        // this.buttonReport.on('pointerdown', this.buttonReport_onClick.bind(this));
        // this.stage.addChild(this.buttonReport);

       //buttonProfileDetails 
        this.buttonProfileDetails = new ButtonSmall("Details", 0x218414, 100);
        this.buttonProfileDetails.interactive = true;
        this.buttonProfileDetails.on('pointerdown', this.buttonProfileDetails_onClick.bind(this));
        this.stage.addChild(this.buttonProfileDetails);

        //player1TurnTimer
        this.player1TurnTimer = new TurnTimer();
        this.stage.addChild(this.player1TurnTimer);

        //player2TurnTimer
        this.player2TurnTimer = new TurnTimer();
        this.stage.addChild(this.player2TurnTimer);


        //TurnIndicator 1
        this.player1TurnIndicator = new TurnIndicator(0x479ACE);
        this.stage.addChild(this.player1TurnIndicator);


        //TurnIndicator 2
        this.player2TurnIndicator = new TurnIndicator(0xC03500);
        this.stage.addChild(this.player2TurnIndicator);




        //create text style

        var stylePlayCount = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 100,
            fill: '#FFFFFF',
            align: 'center'
        });
        var styleInstructions = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 40,
            fill: '#FFFFFF',
            wordWrapWidth: 800,
            align: 'center'
        });
        //create text for play count
        this.playCount = new PIXI.Text('', stylePlayCount);
        this.playCount.anchor.set(0.5, 0);
        this.stage.addChild(this.playCount);

        // //create text - state
        // this.textState = new PIXI.Text('Current State', styleLarge);
        // this.textState.x = 20;
        // this.textState.y = -50;
        // this.stage.addChild(this.textState);

        //instructions Bottom
        this.instructions1 = new PIXI.Text('', styleInstructions);
        this.instructions1.anchor.set(0.5, 0);
        this.stage.addChild(this.instructions1);

        //instructions Top
        this.instructions2 = new PIXI.Text('', styleInstructions);
        this.instructions2.anchor.set(0.5, 0);
        this.stage.addChild(this.instructions2);

        //invalid move text Bottom
        this.invalidMove1 = new PIXI.Text('', styleInstructions);
        this.invalidMove1.anchor.set(0.5, 0);
        this.stage.addChild(this.invalidMove1);

        //invalid move text Top
        this.invalidMove2 = new PIXI.Text('', styleInstructions);
        this.invalidMove2.anchor.set(0.5, 0);
        this.stage.addChild(this.invalidMove2);

        //cards
        this.cardsUI = new Cards(this.cribbage.cards);
        this.cardsUI.zOrder = 100;
        this.cardsUI.cardTouched = this.onCardTouched.bind(this);
        this.stage.addChild(this.cardsUI);
        //force card to move to position
        this.cardsUI.updateCards(this.cribbage.cards, this.pileLayout);


        //hand score button
        this.buttonScoreHand1 = new ButtonSmall("5 🔎", 0x479ACE, 80);
        this.buttonScoreHand1.interactive = true;
        this.buttonScoreHand1.visible = false;
        this.buttonScoreHand1.on('pointerdown', this.btnHand1_onClick.bind(this));
        this.stage.addChild(this.buttonScoreHand1);

        //hand score button
        this.buttonScoreHand2 = new ButtonSmall("5 🔎", 0xC03500, 80);
        this.buttonScoreHand2.interactive = true;
        this.buttonScoreHand2.visible = false;
        this.buttonScoreHand2.on('pointerdown', this.btnHand2_onClick.bind(this));
        this.stage.addChild(this.buttonScoreHand2);

        //hand crib score button
        this.buttonScoreCrib1 = new ButtonSmall("5 🔎", 0x479ACE, 80);
        this.buttonScoreCrib1.interactive = true;
        this.buttonScoreCrib1.visible = false;
        this.buttonScoreCrib1.on('pointerdown', this.btnCrib1_onClick.bind(this));
        this.stage.addChild(this.buttonScoreCrib1);

        //hand crib score button
        this.buttonScoreCrib2 = new ButtonSmall("5 🔎", 0xC03500, 80);
        this.buttonScoreCrib2.interactive = true;
        this.buttonScoreCrib2.visible = false;
        this.buttonScoreCrib2.on('pointerdown', this.btnCrib2_onClick.bind(this));
        this.stage.addChild(this.buttonScoreCrib2);

        //buttonScoreAnalyzer1
        this.buttonScoreAnalyzer1 = new ButtonSmallInfo("5 🔎", 0x444444, 40);
        this.buttonScoreAnalyzer1.interactive = true;
        this.buttonScoreAnalyzer1.visible = false;
        this.buttonScoreAnalyzer1.on('pointerdown', this.btnAnalyzer1_onClick.bind(this));
        this.stage.addChild(this.buttonScoreAnalyzer1);

        //buttonScoreAnalyzer2
        this.buttonScoreAnalyzer2 = new ButtonSmallInfo("5 🔎", 0x444444, 40);
        this.buttonScoreAnalyzer2.interactive = true;
        this.buttonScoreAnalyzer2.visible = false;
        this.buttonScoreAnalyzer2.on('pointerdown', this.btnAnalyzer2_onClick.bind(this));
        this.stage.addChild(this.buttonScoreAnalyzer2);



        //sort button
        this.btnSort = new Button("Sort", 0x999999);
        this.btnSort.x = 265;
        this.btnSort.y = 220;
        this.btnSort.interactive = true;
        this.btnSort.visible = false;
        this.btnSort.on('pointerdown', this.btnSort_onClick.bind(this));
        this.stage.addChild(this.btnSort);

        //confirm button
        this.buttonConfirm = new Button("Confirm", 0x479ACE);
        this.buttonConfirm.interactive = true;
        this.buttonConfirm.visible = false;
        this.buttonConfirm.on('pointerdown', this.buttonConfirm_onClick.bind(this));
        this.stage.addChild(this.buttonConfirm);

        //start button
        this.buttonReady = new Button("Ready", 0x479ACE);
        this.buttonReady.interactive = true;
        this.buttonReady.visible = false;
        this.buttonReady.on('pointerdown', this.buttonReady_onClick.bind(this));
        this.stage.addChild(this.buttonReady);

        //create pop up message for points
        this.textPopUpMessage1 = new PopUpMessage();
        this.stage.addChild(this.textPopUpMessage1);

        //create pop up message for points
        this.textPopUpMessage2 = new PopUpMessage();
        this.stage.addChild(this.textPopUpMessage2);

        //ChatSelection popup
        this.chatSelection = new ChatSelection("");
        this.chatSelection.x = (this.stageWidth / 2);
        this.chatSelection.y = (this.stageHeight / 2);
        this.chatSelection.visible = false;
        this.chatSelection.zOrder = 200;
        this.chatSelection.onSelect = this.chatSelection_onSelect.bind(this);
        this.stage.addChild(this.chatSelection);

        //Game over popup
        this.gameOver = new GameOver();
        this.gameOver.x = (this.stageWidth / 2);
        this.gameOver.y = (this.stageHeight / 2);
        this.gameOver.visible = false;
        this.gameOver.zOrder = 200;
        this.gameOver.onClose = this.gameOver_onClick.bind(this);
        this.gameOver.onRematch = this.gameOver_onRematch.bind(this);
        this.gameOver.onDetails = this.gameOver_onDetails.bind(this);
        this.stage.addChild(this.gameOver);


        //RoundOver
        this.roundOver = new RoundOver();
        this.roundOver.visible = false;
        this.roundOver.onDetails = this.showRoundDetails.bind(this);
        this.roundOver.onNext = this.btnNext_onClick.bind(this);
        this.stage.addChild(this.roundOver);

        //RoundSummary
        this.roundSummary = new RoundSummary();
        this.roundSummary.visible = false;
        this.roundSummary.onExplain = this.showRoundDetails.bind(this);
        this.roundSummary.onNext = this.btnNext_onClick.bind(this);
        this.roundSummary.onAnalyze = this.showAnalyzeHand.bind(this);
        this.stage.addChild(this.roundSummary);


        this.handAnalyzerPanel = new HandAnalyzerPanel();
        this.handAnalyzerPanel.visible = false;
        this.handAnalyzerPanel.interactive = true;
        this.handAnalyzerPanel.on('pointerdown', this.btnAnalyzeHand_onClick.bind(this));
        this.stage.addChild(this.handAnalyzerPanel);




        //ChatBubble 1
        this.chatBubble1 = new ChatBubble('');
        this.stage.addChild(this.chatBubble1);

        //ChatBubble 2
        this.chatBubble2 = new ChatBubble('');
        this.stage.addChild(this.chatBubble2);


        //click anywhere
        this.stage.interactive = true;
        this.stage.on('pointerdown', this.onClick.bind(this));

        this.updateLayout();

        this.start();
        this.isCreated = true;
    }
    resize(appWidth, appHeight) {

        let isLandscape = appWidth > appHeight;
        if (isLandscape) {
            this.stageWidth = 800; //could be dynamic
            this.stageHeight = 500;
            this.orientation = "landscape";
        } else {
            this.orientation = "portrait";
            this.stageWidth = 500;
            this.stageHeight = 800; //could be dynamic
        }

        this.updateLayout();
    }
    updateLayout() {

        this.pileLayout = this.getLayout(this.tablePosition, this.orientation);

        //loop through all the layout properties and set them to the layout manager
        this.layoutManager.updateAllLayoutProperties(this, this.pileLayout);




        //todo: move to class and load dynamicly
        //background
        let resourceBackground = PIXI.Loader.shared.resources[this.cribbage.background]; //preloadded
        if (resourceBackground && resourceBackground.texture) {
            this.background.texture = resourceBackground.texture;
        }

        this.cribbageBoard.board = this.cribbage.boardName;
        this.cribbageBoard.updateLayout();

        //roundSummary
        // //test - remove
        //this.roundSummary.visible = true;
        // this.roundOver.visible = true;




        //Player scoreboard
        if (this.cribbage.player1) {
            this.profile1.name = this.cribbage.player1.name || "";
            this.profile1.avatar = this.cribbage.player1.avatar;
            this.profile1.rank = this.cribbage.player1.rank;
            // if (this.cribbage.player1.isDisconnected) {
            //     this.profile1.avatar = "Avatar_Disconnected";
            // }
        }

        this.profile1.updateLayout();



        //Player scoreboard
        if (this.cribbage.player2) {
            this.profile2.name = this.cribbage.player2.name || "";
            this.profile2.avatar = this.cribbage.player2.avatar;
            this.profile2.rank = this.cribbage.player2.rank;
            // if (this.cribbage.player2.isDisconnected) {
            //     this.profile2.avatar = "Avatar_Disconnected";
            // }
        }
        this.profile2.updateLayout();

        //Disconnected indicator 1
        if (this.cribbage.player1) {
            let isDisconnected1 = this.cribbage.player1.isDisconnected;
            this.player1Disconnected.visible = isDisconnected1;
        }

        //Disconnected indicator 2
        if (this.cribbage.player2) {
            let isDisconnected2 = this.cribbage.player2.isDisconnected;
            this.player2Disconnected.visible = isDisconnected2;
        }

        //ChatMute indicator  
        this.chatMute.visible = this.isChatMuted;

        //Audio button
        this.buttonAudio.visible = !this.isAudioMuted;
        this.buttonAudioMute.visible = this.isAudioMuted;



        //create text for play count
        this.playCount.text = this.cribbage.playCount;

        //instructions Bottom
        this.instructions1.text = this.cribbage.messagePlayer1;

        //instructions Top
        this.instructions2.text = this.cribbage.messagePlayer2;



        //force card to move to position
        this.cardsUI.updateCards(this.cribbage.cards, this.pileLayout);
        this.cardsUI.deckName = this.cribbage.deckName;
        this.cardsUI.updateLayout();


        this.handAnalyzerPanel.y = 455;
        this.handAnalyzerPanel.zOrder = 200;
        this.handAnalyzerPanel.updateLayout();
        //could pull data here, but it should not do calculations even layout update.


        this.showMatchPoints();
        this.showTurnIndicator(this.cribbage.playerTurn);

        // //create text - state
        // let state = this.cribbage.currentState;
        // this.textState.x = 20;
        // this.textState.y = -50;
        // this.textState.text = state;

        //ready button
        let canReady = this.cribbage.canReady(this.tablePosition);
        this.buttonReady.visible = canReady;

        //check for state change
        if (this.state !== this.cribbage.currentState) {
            this.state = this.cribbage.currentState;
            this.onStateChanged();
        }



        this.isDirty = true;
    }
    start() {
        //this.cribbage.action("start");
        //note: trigger onStateChange on the UI - resuming will not trigger it and thus not show some ui elements needed
        this.onStateChanged();
        this.update(true);
    }

    error(cardUI) {
        console.error(`cardUI id: ${cardUI.id} should never be at this location with this targetX: ${cardUI.targetX}`);
        // let cardUIData = {
        //     id:cardUI.id,
        //     targetX: cardUI.targetX,
        //     targetY: cardUI.targetY,
        //     x: cardUI.x,
        //     y: cardUI.y
        // }
        // console.error(cardUIData);
        // let cribbageData = this.cribbage.save();
        // console.error(cribbageData);
        // debugger;
    }
    playSound(id) {
        if (this.audio) {
            this.audio.play(id);
        }
        // const sound = PIXI.sound.find(id);
        // //multi play a not preloaded resource cause crash - https://github.com/pixijs/sound/issues/71
        // if (sound && sound.isLoaded) {
        //     PIXI.sound.play(id);
        // }
    }
    update(force) {


        if (force) this.isDirty = true;

        //this.stage (containter) is dirty, before this was the pixi containter now it has a property stage for pixi containter
        //could change game engine to look at scene.stage and push all this.dirty to the this.stage (containter)
        if (this.stage.isDirty) {
            this.stage.isDirty = false;
            this.isDirty = true;
        }

        //get tick.  This will also tick the players to play if they can without using timers
        if (this.cribbage)
            this.cribbage.tick();


        //update ui needed, else sleep. event or click to wake up.
        //animation until nothing needs animation (each animation call return true if more animations are needed. or a function call to check. 
        //or timer

        if (this.cardsUI.hasCardMoved()) {
            this.playSound("CardClick");
        }

        let cIsDirty = this.cardsUI.update(force);
        if (cIsDirty)
            this.isDirty = true;
        else {
            // this.validateTweenEnd();
        }

        let bIsDirty = this.cribbageBoard.update();
        if (bIsDirty) this.isDirty = true;

        let ptIsDirty = this.textPopUpMessage2.update();
        if (ptIsDirty) this.isDirty = true;

        let pbIsDirty = this.textPopUpMessage1.update();
        if (pbIsDirty) this.isDirty = true;

        let tttIsDirty = this.player1TurnTimer.update();
        if (tttIsDirty) this.isDirty = true;

        let ttbIsDirty = this.player2TurnTimer.update();
        if (ttbIsDirty) this.isDirty = true;

        let cbtIsDirty = this.chatBubble1.update();
        if (cbtIsDirty) this.isDirty = true;

        let cbbIsDirty = this.chatBubble2.update();
        if (cbbIsDirty) this.isDirty = true;



        //should not be updating profile pic texture every frame 
        // let ps1IsDirty = this.profile1.update();
        // if (ps1IsDirty) this.isDirty = true;

        // let ps2IsDirty = this.profile2.update();
        // if (ps2IsDirty) this.isDirty = true;

        // // //if (this.debug) {
        //     this.validateCardPileZ();
        //      this.validateTweenEnd();
        //      this.validateCardTargetX();
        // // //}
    }
    render() {
        this.isDirty = false;
    }

    /////user input////////////////
    onCardTouched(event) {
        let cardId = event.currentTarget.id;

        //todo: on crib state, stage/select the cards. play is playing to the crib
        let state = this.cribbage.currentState;
        if (state === "crib") {
            this.cribbage.action("select", cardId, this.tablePosition);
        } else {
            this.cribbage.action("play", cardId, this.tablePosition);
        }
    }
    onClick(event) {
        this.nextAction(this.tablePosition);
        this.isDirty = true;
    }
    buttonConfirm_onClick() {
        this.cribbage.action("confirm", null, this.tablePosition);
    }
    btnSort_onClick() {
        this.cribbage.action("sort", null, this.tablePosition);
    }

    buttonReady_onClick() {
        this.cribbage.action("start", null, this.tablePosition);
    }

    buttonExit_onClick() {

        //rules to allow quit without penalty
        if (this.cribbage) {
            let allowQuit = this.cribbage.canQuit(this.tablePosition);
            let level = this.cribbage.level;
            if (!allowQuit && level === "Online") {
                let dialogBox = new DialogBox("Quit?", "You will recieve a loss if you quit without finishing the game.");
                dialogBox.x = (this.stageWidth / 2);
                dialogBox.y = (this.stageHeight / 2);
                dialogBox.zOrder = 100;
                dialogBox.onConfirm = this.quit.bind(this);
                this.stage.addChild(dialogBox);
                return;
            }
        }

        this.quit("Exit");
        return;

    }
    quit(reason) {
        this.cribbage.action("quit", reason, this.tablePosition);
        this.app.quitGame();
        this.shutdown();
    }
    gameOver_onRematch() {
        this.cribbage.action("playAgain", null, this.tablePosition);
    }
    gameOver_onClick() {
        this.app.quitGame();
    }
    gameOver_onDetails() {
        this.showMatchDetails();
    }

    buttonReport_onClick() {
        this.muteChat(true);

        let player = null;
        if (this.tablePosition === "player1")
            player = this.cribbage.player2;
        if (this.tablePosition === "player2")
            player = this.cribbage.player1;

        if (player) {
            this.app.showReportPopup(player);
           // this.app.showBlockPopup(player);
            //this.app.blockPlayer(player.id, player.name);
        }
    }
    buttonAddFriend_onClick() {
        let invitee = null;
        if (this.tablePosition === "player1")
            invitee = this.cribbage.player2;
        if (this.tablePosition === "player2")
            invitee = this.cribbage.player1;
        this.app.addFriend(invitee);
    }
    buttonMute_onClick() {
        //this.showRoundSummary() ;
        //this.showGameOver() ;
        //this.cribbage.action("quit", null, this.tablePosition);
        this.muteAudio(!this.isAudioMuted);
    }
    buttonQuit_onClick() { //quit and not leave
        this.cribbage.action("quit", null, this.tablePosition);
    }
    buttonChat_onClick() {
        // this.chatSelection.visible = true;
        // this.isDirty = true;
        this.app.showChat(this.cribbage.allowFullChat);
    }
    chatSelection_onSelect(value) {
        //send action to cribbage core and add event listener for it as player position of ui
        this.cribbage.action("chat", value, this.tablePosition);
    }
    profile1_onClick(event) {
        // // this.showGameOver();
        // //event.stopPropagation();
        // // this.chatBubble1.show("Hello Abby");
        // //this.cribbage.action("chat", "Hello Abby", "player1");
        // if (this.tablePosition === "player1") {
        //     this.chatSelection.visible = true;
        //     this.isDirty = true;
        // }
        if (this.tablePosition === "player1") {
            this.app.showChat(this.cribbage.allowFullChat);
        } else {
            //this.muteChat(!this.isChatMuted);
            //show user options: report, mute, block, friend
            this.app.showProfile(this.cribbage.player1);
        }
    }
    profile2_onClick(event) {
        // //// //this.showHandDetails("player2", "Computer's Hand");
        // //this.showRoundSummary();
        // //event.stopPropagation();

        // // this.chatSelection.visible = true;
        // // this.isDirty = true;
        // //  this.cribbage.action("chat", "Hello Abby", "player2");
        // if (this.tablePosition === "player2") {
        //     this.chatSelection.visible = true;
        //     this.isDirty = true;
        // }
        //this.onChat("Mooooo","player2");
        if (this.tablePosition === "player2") {
            this.app.showChat(this.cribbage.allowFullChat);
        } else {
            //this.muteChat(!this.isChatMuted);
            //show user options: report, mute, block, friend
            this.app.showProfile(this.cribbage.player2);
        }

    }
    buttonProfileDetails_onClick(){
        if (this.tablePosition === "player1") {
            this.app.showProfile(this.cribbage.player2);
        } else {
            this.app.showProfile(this.cribbage.player1);
        }
    }
    btnHand1_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showHandDetails("player1", round);

        event.stopPropagation();
    }
    btnHand2_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showHandDetails("player2", round);
        event.stopPropagation();
    }
    btnCrib1_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showCribDetails("crib", round, "Crib");
        event.stopPropagation();
    }
    btnCrib2_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showCribDetails("crib", round, "Crib");
        event.stopPropagation();
    }
    btnNext_onClick() {
        this.nextAction(this.tablePosition);
    }
    btnExplain_onClick(event) {
        // this.showHandDetails("crib", "Crib");
        // this.showHandDetails("player2", "Computer's Hand");
        // this.showHandDetails("player1", "Players's Hand");
        this.showRoundDetails();
        event.stopPropagation();
    }
    btnAnalyzeHand_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showAnalyzeHand(round);
        event.stopPropagation();
    }
    btnAnalyzer1_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showAnalyzeHand(round, "player1");
        event.stopPropagation();
    }
    btnAnalyzer2_onClick(event) {
        let round = this.cribbage.roundNumber;
        this.showAnalyzeHand(round, "player2");
        event.stopPropagation();
    }
    ////////ui helpers///////////////
    nextAction(player) {
        if (!this.cribbage) return;
        if (!this.cribbage.getActions) return;
        let actions = this.cribbage.getActions(player).map(x => x.command);
        if (actions.includes("next") === true) {
            this.cribbage.action("next", null, player);
        }
        this.isDirty = true;
    }
    muteChat(isMuted) {
        this.isChatMuted = isMuted;
        this.updateLayout();
        this.isDirty = true;
    }
    muteAudio(isMuted) {
        this.isAudioMuted = isMuted;
        this.app.muteSet(isMuted);
        this.updateLayout();
        this.isDirty = true;
    }
    showHandDetails(player, round) {

        let summary = this.cribbage.scoreHandDetail(player, round);

        let title = summary.name + "'s Hand";
        if (summary.name === "You") title = "Your Hand";
        //scoreDetails
        this.scoreDetails = new ScoreDetails(title, summary.starterCard, summary.hand, summary.points);
        this.scoreDetails.x = (this.stageWidth / 2);
        this.scoreDetails.y = (this.stageHeight / 2);
        this.scoreDetails.zOrder = 110;
        this.stage.addChild(this.scoreDetails);

        this.isDirty = true;
    }
    showCribDetails(player, round, title) {

        let summary = this.cribbage.scoreCribDetail(round);

        //scoreDetails
        this.scoreDetails = new ScoreDetails(title, summary.starterCard, summary.hand, summary.points);
        this.scoreDetails.x = (this.stageWidth / 2);
        this.scoreDetails.y = (this.stageHeight / 2);
        this.scoreDetails.zOrder = 110;
        this.stage.addChild(this.scoreDetails);

        this.isDirty = true;
    }
    showRoundSummaryWindow(player) {
        if (!player) player = this.tablePosition;

        let scoreSummary = this.cribbage.roundSummary();

        //round summary popup
        this.roundSummaryWindow = new RoundSummaryWindow();
        this.roundSummaryWindow.x = (this.stageWidth / 2);
        this.roundSummaryWindow.y = (this.stageHeight / 2);
        this.roundSummaryWindow.zOrder = 110;
        this.stage.addChild(this.roundSummaryWindow);

        //populate
        this.roundSummaryWindow.updateScore(scoreSummary);
        this.roundSummaryWindow.onAnalyze = this.showAnalyzeHand.bind(this);

        this.isDirty = true;
    }
    showMatchSummary() {
        let scoreSummary = this.cribbage.matchSummary();

        //round summary popup
        this.matchSummary = new MatchSummary();
        this.matchSummary.x = (this.stageWidth / 2);
        this.matchSummary.y = (this.stageHeight / 2);
        this.matchSummary.zOrder = 110;
        this.stage.addChild(this.matchSummary);

        //populate
        this.matchSummary.updateScore(scoreSummary);

        this.isDirty = true;
    }
    showRoundSummary(tablePosition, hideContinue) {
        if (!tablePosition) tablePosition = this.tablePosition;

        let scoreSummary = this.cribbage.roundSummary();
        let round = scoreSummary.round;
        let players = this.cribbage.tablePositions; 

        //create view model for round summary
        let viewModel = {
            round: round,
            players: players.map(player => ({
                name: scoreSummary[player].name,
                avatar: scoreSummary[player].avatar,
                tablePosition: player,
                starter: scoreSummary[player].starter,
                play: scoreSummary[player].play,
                hand: scoreSummary[player].hand,
                crib: scoreSummary[player].crib,
                total: scoreSummary[player].total,
                analyzerScore: scoreSummary[player].analyzerScore,
            }))
        };

        //populate
        this.roundSummary.populate(viewModel, tablePosition);

        //show round summary 
        this.roundSummary.visible = true;
        this.isDirty = true;
    }
    showRoundOver(player, hideContinue) {
        if (!player) player = this.tablePosition;

        //populate
        this.roundOver.tablePosition = player;
        this.roundOver.hideContinue = hideContinue;


        //show round summary 
        this.roundOver.visible = true;
        this.isDirty = true;
    }
    showHandCount() {
        //get data
        let scoreSummary = this.cribbage.roundSummary();

        //show hand points
        let hand1Score = scoreSummary["player1"] ? scoreSummary["player1"].hand : 0;
        let hand2Score = scoreSummary["player2"] ? scoreSummary["player2"].hand : 0;
        let crib1Score = scoreSummary["player1"] ? scoreSummary["player1"].crib : 0;
        let crib2Score = scoreSummary["player2"] ? scoreSummary["player2"].crib : 0;
        let hand1AnalyzerScore = scoreSummary["player1"] ? scoreSummary["player1"].analyzerScore : 0;
        let hand2AnalyzerScore = scoreSummary["player2"] ? scoreSummary["player2"].analyzerScore : 0;

        let dealer = this.cribbage.dealer;

        this.buttonScoreHand1.text = hand1Score + "✋";
        //"6 📍" + hand1Score + " 🃏 5 📦= 12     🖩 90";
        this.buttonScoreHand2.text = hand2Score + "✋";//  + " 🔎";

        this.buttonScoreCrib1.text = crib1Score + "🐱";// + " 🔎";
        this.buttonScoreCrib2.text = crib2Score + "🐱";//  + " 🔎";

        this.buttonScoreHand1.visible = true;
        this.buttonScoreHand2.visible = true;
        if (dealer === "player1") this.buttonScoreCrib1.visible = true;
        if (dealer === "player2") this.buttonScoreCrib2.visible = true;


        this.buttonScoreAnalyzer1.text = hand1AnalyzerScore + "%";
        this.buttonScoreAnalyzer1.visible = true;

        this.buttonScoreAnalyzer2.text = hand2AnalyzerScore + "%";
        this.buttonScoreAnalyzer2.visible = true;



        this.isDirty = true;
    }
    showAnalyzeHandSummary(player) {
        if (!player) player = this.tablePosition;
        let optimalAvgHand = this.cribbage.analyzeSeletedHand(player);
        this.handAnalyzerPanel.analyzeScore = optimalAvgHand;
        this.handAnalyzerPanel.updateLayout();
        this.handAnalyzerPanel.visible = true;
    }
    showAnalyzeHand(round, player) {
        if (!player) player = this.tablePosition;
        if (typeof round !== 'number') round = this.cribbage.roundNumber;
        let analysis = this.cribbage.analyzeHand(player, round);
        this.app.showAnalyzeHand(analysis);
    }
    showMatchPoints() {
        let matchPoints = this.cribbage.matchPoints;

        //needs to be called only on summary point updates for hand / crib
        this.cribbageBoard.updateScore(matchPoints["player1"], matchPoints["player2"]);

        //this.scoreboard.updateScore(matchPoints["player1"] || 0, matchPoints["player2"] || 0)

        this.profile1.updateScore(matchPoints["player1"] || 0)
        this.profile2.updateScore(matchPoints["player2"] || 0)
    }
    showGameOver() {
        //play sound
        this.playSound("AchivementSound");

        //dont show on test
        if (this.isTest()) return;

        let matchPoints = this.cribbage.matchPoints;
        let isSkunked = this.cribbage.isSkunked;
        let message = "You win!";
        let player1 = this.cribbage.player1 ? this.cribbage.player1.name : "You";
        let player2 = this.cribbage.player2 ? this.cribbage.player2.name : "Computer";

        let allowRematch = this.cribbage.allowRematch;
        let readyPlayer1 = this.cribbage?.player1?.ready;
        let readyPlayer2 = this.cribbage?.player2?.ready;

        let matchWinnerName = "";
        if (this.cribbage.matchWinner === "player1") matchWinnerName = player1;
        if (this.cribbage.matchWinner === "player2") matchWinnerName = player2;

        message = matchWinnerName + " wins!";
        if (matchWinnerName === "You") message = "You win!";

        this.gameOver.message = message;
        this.gameOver.scorePlayer1 = matchPoints["player1"];
        this.gameOver.scorePlayer2 = matchPoints["player2"];
        this.gameOver.player1Name = player1;
        this.gameOver.player2Name = player2;
        this.gameOver.readyPlayer1 = readyPlayer1;
        this.gameOver.readyPlayer2 = readyPlayer2;
        this.gameOver.isSkunked = isSkunked;
        this.gameOver.allowRematch = allowRematch;
        this.gameOver.update();
        this.gameOver.visible = true;

        this.isDirty = true;


    }
    isTest() {
        // let player = this.tablePosition == "player1" ? this.cribbage.player1 : this.cribbage.player2;
        // let isTest = false;
        // if (player && player.behavior === "test") isTest = true;
        // return isTest;

        if (this.cribbage.debugUI == true)
            return true;

        //return false;
    }
    showRoundDetails(round) {

        this.showCribDetails("crib", round, "Crib");
        this.showHandDetails("player2", round, "Computer's Hand");
        this.showHandDetails("player1", round, "Players's Hand");
        //this.showRoundSummaryWindow();
        this.isDirty = true;
    }
    showMatchDetails(round) {
        this.showMatchSummary();
        //this.showRoundSummaryWindow();
        this.showCribDetails("crib", round, "Crib");
        this.showHandDetails("player2", round, "Computer's Hand");
        this.showHandDetails("player1", round, "Players's Hand");
        this.isDirty = true;
    }
    showPointPopUp(player, message) {

        //Show popup
        if (player == "player1") {
            this.textPopUpMessage1.show(message);
        }
        if (player == "player2") {
            this.textPopUpMessage2.show(message);
        }

        //play sound
        this.playSound("PointSound");
    }

    showTurnIndicator(playerTurn) {
        this.player1TurnIndicator.visible = false;
        this.player2TurnIndicator.visible = false;
        this.player1TurnTimer.visible = false;
        this.player2TurnTimer.visible = false;

        if (playerTurn === "player1") {
            this.player1TurnIndicator.visible = true;
            this.player1TurnTimer.visible = true;
        }
        if (playerTurn === "player2") {
            this.player2TurnIndicator.visible = true;
            this.player2TurnTimer.visible = true;
        }

        this.isDirty = true;
    }
    ////////events from model///////////
    onAwardPoints(pointLogArray) {
        if (!pointLogArray) return false;
        if (pointLogArray.length == 0) return false;

        let showGrouped = false;
        let state = pointLogArray[0].state; //this.cribbage.currentState
        if (state === "showNonDealerHand" || state === "showDealerHand" || state === "showCrib")
            showGrouped = true;

        //note: could show each delayed so all dont show at once

        //single point log
        if (!showGrouped) {
            let messages = [];
            for (let i = 0; i < pointLogArray.length; i++) {
                let p = pointLogArray[i];
                //this.showPointPopUp(p.player, p.points, p.reason,);
                let message = '+' + p.points + '  ' + p.reason;
                messages.push(message);
            }
            let player = pointLogArray[0].player;
            let message = messages.join('\n');
            this.showPointPopUp(player, message);
        }
        // //multiple point log: show grouped name as a single point ui popup
        // if (showGrouped) {
        //     let points = pointLogArray.reduce(function (total, item) {
        //         return total + item.points;
        //     }, 0);
        //     let reason = pointLogArray[0].pile;
        //     let player = pointLogArray[0].player;
        //     //this.showPointPopUp(player, points, reason);
        //     this.showPointPopUp(player, '+' + points + '  ' + reason);
        // }


        //{"event":"awardPointsArray","value":[{"points":2,"player":"player2","reason":"fifteen two","pile":"crib","cards":["5h","13d"],"state":"show","round":2}],"timestamp":169.876}
        ////{"event":"awardPoints","value":{"points":2,"player":"player2","reason":"fifteen two","pile":"crib","cards":["5h","13d"],"state":"show","round":2},"timestamp":169.876}
    }
    onHandPoints(message, player) {
        this.showPointPopUp(player, '+' + message);
    }
    onMatchPoints(matchPoints) {
        this.showMatchPoints();
    }
    onStateChanged() {
        //OnStateChange
        let state = this.cribbage.currentState;
        let sortHands = this.cribbage.sortHands;
        //this.textState.text = state;

        this.instructions1.text = this.cribbage.messagePlayer1;
        this.instructions2.text = this.cribbage.messagePlayer2;


        this.showTurnIndicator(this.cribbage.playerTurn);
        if (state === "showNonDealerHand") {

        }
        if (state === "showDealerHand") {

        }
        if (state === "showCrib") {

        }
        if (state === "endRound") {
            //this.showRoundSummary();
            //this.playSound("WinSound");
            //this.showRoundEnd();
            this.showRoundSummary();
            //this.showRoundOver()
            //this.showHandCount();

            //this.showAnalyzeHandSummary();
            //  this.buttonScoreHand1.visible = true;
            //  this.buttonScoreHand2.visible = true;
            //  this.buttonScoreCrib1.visible = true;
            //  this.buttonScoreCrib2.visible = false;
        } else {
            this.roundSummary.visible = false;
            this.roundOver.visible = false;
            //this.handAnalyzerPanel.visible = false;

            this.buttonScoreHand1.visible = false;
            this.buttonScoreHand2.visible = false;
            this.buttonScoreCrib1.visible = false;
            this.buttonScoreCrib2.visible = false;
            this.buttonScoreAnalyzer1.visible = false;
            this.buttonScoreAnalyzer2.visible = false;
        }
        if (state === "startRound") {

        }
        if (state === "crib" && !sortHands) {
            this.btnSort.visible = true;
        } else {
            this.btnSort.visible = false;
        }
        if (state === "play") {
            //this.roundSummary.visible = false;
        }
        if (state === "endMatch") {
            this.showGameOver();
            //this.showRoundSummary(null, true);
        } else {
            // this.gameOver.visible = false;
        }
        if (state === "preGame") {
            //this.roundSummary.visible = false;
            this.gameOver.visible = false;
        }
        //this.handAnalyzerPanel.visible = true;  
        //this.gameOver.visible = true;
        // this.showRoundSummary();
        //this.gameOver.visible = true;
        //this.updateLayout();

        this.isDirty = true;
    }
    onActionStart(args) {
        // this.instructions2.text = "";
        // this.instructions1.text = "";
        //this.textPopUpMessage1.hide();
        // this.textPopUpMessage2.hide();
    }
    onActionEnded(args) {
        this.playCount.text = this.cribbage.playCount;


        this.instructions1.text = this.cribbage.messagePlayer1;
        this.instructions2.text = this.cribbage.messagePlayer2;

        this.showTurnIndicator(this.cribbage.playerTurn);


        this.invalidMove2.text = '';
        this.invalidMove1.text = '';

        let canConfirm = this.cribbage.canConfirm(this.tablePosition);
        this.buttonConfirm.visible = canConfirm;

        let canReady = this.cribbage.canReady(this.tablePosition);
        this.buttonReady.visible = canReady;

        let canSort = this.cribbage.canSort(this.tablePosition);
        this.btnSort.visible = canSort;

        //show ready indicator
        //todo: delete " this.cribbage.readyPlayer1" after all have upgraded 2/11/2020
        //let readyPlayer1 = this.cribbage.readyPlayer1;
        //let readyPlayer2 = this.cribbage.readyPlayer2;
        //let readyPlayer1 = this.cribbage.player1 ? this.cribbage.player1.ready : false;
        //let readyPlayer2 = this.cribbage.player2 ? this.cribbage.player2.ready : false;
        let player1 = this.cribbage.player1;
        let player2 = this.cribbage.player2;
        let readyPlayer1 = this.cribbage?.player1?.ready;
        let readyPlayer2 = this.cribbage?.player2?.ready

        this.gameOver.readyPlayer1 = readyPlayer1;
        this.gameOver.readyPlayer2 = readyPlayer2;
        this.gameOver.update();

        //show ready indicator
        this.roundSummary.readyPlayer1 = readyPlayer1;
        this.roundSummary.readyPlayer2 = readyPlayer2;
        this.roundSummary.update();

        this.roundOver.readyPlayer1 = readyPlayer1;
        this.roundOver.readyPlayer2 = readyPlayer2;
        this.roundOver.update();

        this.isDirty = true;
    }
    onInvalidMove(msg, player) {
        if (player === "player1")
            this.invalidMove1.text = msg;
        if (player === "player2")
            this.invalidMove2.text = msg;
        this.isDirty = true;
    }
    onMessage(msg, player) {
        // if (player === "player1" || player === undefined)
        //     this.instructions1.text = msg;
        // else
        //     this.instructions2.text = msg;
    }
    onCardMoved(args) {
        this.cardsUI.updateCards(this.cribbage.cards, this.pileLayout);
        // this.playSound("CardClick");

        this.isDirty = true;
    }
    onJoin(args) {
        // //todo: should matching local ui to controlling playe be done here?
        // if (this.cribbage.player1 && this.tablePosition === this.cribbage.player1.name) {
        //     this.tablePosition = "player1";
        // }
        // if (this.cribbage.player2 && this.tablePosition === this.cribbage.player2.name) {
        //     this.tablePosition = "player2";
        // }
        this.onStateChanged();
        this.updateLayout();
        this.isDirty = true;
    }
    onLeave(args) {
        this.updateLayout();
        this.isDirty = true;
    }
    onDisconnect() {
        this.updateLayout();
        this.isDirty = true;
    }
    onStartPlayTimer(duration, player) {
        if (player === "player1")
            this.player1TurnTimer.show(duration);
        if (player === "player2")
            this.player2TurnTimer.show(duration);
    }
    onChat(message, player) {
        if (this.isChatMuted) {
            if (this.tablePosition != player) {
                return;
            }
        }
        if (this.app && this.app.translate) {
            message = this.app.translate(message);
        }

        if (player === "player1")
            this.chatBubble1.show(message);
        if (player === "player2")
            this.chatBubble2.show(message);
    }
    onData() {
        this.updateLayout();
        this.isDirty = true;
    }
}